import ServerSettings, {ServerSettingsFieldType} from "../../gd/settings/server-settings/server-settings";

const fieldsConfig = {
    'openLinksInDesktopApp': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : undefined,
    }
}

// const debug = 'UserSettings_DesktopApp'
const debug = false

export default class UserSettings_DesktopApp extends ServerSettings {

    // eta nastroika delaet 2 vechi
    // if true auto set Cookie to open desktop app
    public openLinksInDesktopApp?   : boolean

    constructor(config: JSONObject) {
        super(config, fieldsConfig)

        debug && console.log(debug, 'constructor', config)

        this.openLinksInDesktopApp  = this.initValue('openLinksInDesktopApp')
    }

    toJson() {
        const result = {}
        this.valueToJson(result, 'openLinksInDesktopApp')

        return result
    }
}
